import { AppRoute } from 'app/app-layout/constants/app-route.enum';

export interface RouterRequestInterface {
  route: AppRoute;
  routeParams?: any[];
  queryParams?: object;
}

export class RouterRequest implements RouterRequestInterface {
  public route: AppRoute;
  public routeParams?: any[];
  public queryParams?: object;

  constructor({
      route = AppRoute.myZone,
      routeParams = undefined,
      queryParams = undefined,
    }: RouterRequestInterface) {
    this.route = route;
    this.routeParams = routeParams;
    this.queryParams = queryParams;
  }
}
